import Helpers from "./helpers";
import Hooks from "./hooks";

const GraphicWarehouse = {
    Helpers,
    Hooks
};

export default GraphicWarehouse;
